// extracted by mini-css-extract-plugin
module.exports = {"button":"EventButtons_button__3XJ9x","button_delete":"EventButtons_button_delete__3wvaz","button_add":"EventButtons_button_add__28wb9"};